import React from "react";
import { Button } from "../../pages/home/components/HeroSession.js/HeroSession.styles";
import { FormContainer, InputContainer } from "../betaForm/BetaDetail";

const JollyDetail = () => {
  return (
    <FormContainer>
      <InputContainer>
        <div>
          <label>Where do you work currently?</label>
          <input placeholder="eg Coca Cola" />
        </div>
        <div>
          <label>Monthly Salary?</label>
          <input placeholder="eg 500,000" />
        </div>
        <div>
          <label>Country of Destination</label>
          <input placeholder="eg, Dubai" />
        </div>
        <div>
          <label>Duration of stay</label>
          <input placeholder="eg, 2 weeks" />
        </div>
        <div>
          <label>Do you have an international Passport?</label>
          <input placeholder="" />
        </div>
        <div>
          <label>Have you traveled out of the country before?</label>
          <input placeholder="" />
        </div>
      </InputContainer>
      <div className="submit__button">
        <Button
          style={{ color: "#fff", fontSize: "16px", marginTop: "20px" }}
          to="/contact"
        >
          Finish
        </Button>
      </div>
    </FormContainer>
  );
};

export default JollyDetail;
